import React from "react";
import { FAQ_DATA } from "../data/mock";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Badge } from "./ui/badge";
import { HelpCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export const FAQSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 lg:py-28 bg-white" id="faq">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-12 lg:gap-16">
          {/* Left - Header */}
          <div className="lg:col-span-2 section-reveal">
            <div className="lg:sticky lg:top-32">
              <Badge className="bg-[#F5F1EA] text-[#C8A24D] border-[#E8D5A0] hover:bg-[#F5F1EA] mb-6 py-1.5 px-4 text-xs font-semibold tracking-wide uppercase">
                {t("faq.badge")}
              </Badge>
              <h2 className="text-3xl sm:text-4xl text-[#0C2340] leading-tight mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                {t("faq.title")}
              </h2>
              <p className="text-[#4A5568] leading-relaxed mb-6">
                {t("faq.subtitle")}
              </p>
              <div className="flex items-center gap-3 bg-[#F5F1EA] rounded-xl p-4 border border-[#E8D5A0]/30">
                <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center shrink-0">
                  <HelpCircle className="w-5 h-5 text-[#C8A24D]" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#0C2340]">{t("faq.contactTitle")}</p>
                  <p className="text-xs text-[#7A7A8A]">
                    {t("faq.contactDesc")} <a href="tel:+34624511532" className="hover:text-[#C8A24D] transition-colors">+34 624 511 532</a> {t("faq.contactOr")} <a href="https://wa.me/34624511532" target="_blank" rel="noopener noreferrer" className="text-[#25D366] font-medium hover:underline">{t("faq.whatsapp")}</a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Accordion */}
          <div className="lg:col-span-3 section-reveal">
            <Accordion type="single" collapsible className="space-y-3">
              {FAQ_DATA.map((faq, index) => (
                <AccordionItem
                  key={index}
                  value={`faq-${index}`}
                  className="bg-[#FAFAF7] border border-[#E8E4DC] rounded-2xl px-6 data-[state=open]:bg-white data-[state=open]:border-[#C8A24D]/30 data-[state=open]:shadow-lg data-[state=open]:shadow-[#C8A24D]/5 transition-all duration-300"
                >
                  <AccordionTrigger className="text-left text-[#0C2340] font-semibold text-base hover:no-underline py-5 [&[data-state=open]]:text-[#C8A24D]">
                    {t(`faq.q${index + 1}`)}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#4A5568] leading-relaxed text-sm pb-5">
                    {t(`faq.a${index + 1}`)}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
